<template>
    <div>
      <v-card class="no-display">
        <v-card-text>
        <v-row justify="center">
            <h3>Get Receipts</h3>
        </v-row>
         <v-row justify="center" dense class="mt-3">
          <v-col sm="3">
            <v-combobox
              dense
              required
              v-model="learner"
              :items="learners"
              item-text="name"
              label="Child"
              outlined
            />
          </v-col>          
       
          <v-col sm="3">
            <v-combobox
              dense
              required
              v-model="curr_ay"
              :items="ay_list"
              item-text="Academic Year"
              label="Academic Year"
              outlined
            />
          </v-col>
          <v-col sm="3">
            <v-combobox
              dense
              required
              v-model="fee_type"
              :items="fees_type"
              item-text="Select Fees Type"
              label="Fees Type"
              outlined
            />
          </v-col>          
        </v-row>
        </v-card-text>
      </v-card>
      <br>
      <template>
        <v-simple-table v-if="receipt_list">
          <template v-slot:default>
            <thead>
              <tr>
                <th class="text-left"><b>Sr.No</b></th>
                <th class="text-left"><b>Reciept No</b></th>
                <th class="text-left"><b>Standard</b></th>
                <th class="text-left"><b>Amount</b></th>
                <th class="text-left"><b>Date</b></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, index) in receipt_list" :key="item.name">
                <td>{{ index+1 }}</td>
                <td>
                   <v-btn class="ma-2" tile outlined color="success" @click="callAdmissionFeesReciept(item.id)" title="View Reciept">
                        <v-icon left>mdi-file-eye</v-icon> {{ item.receipt_no }} </v-btn
                      >
                </td>
                <td>{{ item.std }}</td>
                <td>{{ item.amount }}</td>
                <td>{{ item.receipt_date }}</td>
              </tr>
            </tbody>
          </template>
        </v-simple-table>
      </template>
     
    </div>
</template>

<script>
import axios from "axios";
export default {
  data: () => ({
    //api-1
      learners:null,
      learner:null,
      fees_type:null,
      ay_list:null,
      curr_ay:null,
      fee_type:null,
      //api-2
      receipt_list:null,
      org: null,
       
  }),
  watch:{
    learner(){
      this.getReceipt()
    },
    fee_type(){
      this.getReceipt()
    },
    curr_ay(){
      this.getReceipt()
    }
  },
  methods:{
    callAdmissionFeesReciept(id){
      this.$store.commit("setreceipt_id", id);
      this.$router.push({ name: "admission-fees-receipt" });
      return;
    },
    //api-2
    getReceipt(){
      this.receipt_list=null
      if(this.fee_type!=null){
        const formData = {
          learnerid:this.learner.id,
          fee_type:this.fee_type,
          ay:this.curr_ay
        }
        axios
        .post("/parent/getReceipt", formData)
        .then(res => {
          if (res.data.msg == "200") {
            if(res.data.status=="SUCCESS"){
                this.receipt_list = res.data.receipt_list
                this.org = res.data.org
            }
            else{
              alert(res.data.status_reason)
            }
          } 
        })
        .catch(error => {
          window.console.log(error);
        })
        .finally(() => {
          //close loader
        });
      }
    }
  },
  //api-1
  mounted(){
    axios
    .post("/parent/getChild", this.receipt_data)
    .then(res => {
      if (res.data.msg == "200") {
        if(res.data.status=="SUCCESS"){
          this.learners = res.data.learners
          this.learner = this.learners[0]
          this.fees_type = res.data.fees_type
          //this.fee_type = this.fees_type[0]
          this.ay_list = res.data.ay_list
          this.curr_ay = res.data.curr_ay
        }
      } 
    })
    .catch(error => {
      window.console.log(error);
    })
    .finally(() => {
      //close loader
    });
  },

  computed: {
    splitStringByName(){
       var str = this.learner.name;
       var res = str.split(":");
       return res[1];
    }
  }
}
</script>
<style scoped>
@media print {
  @page { size: landscape; }
  body {
    height: 100%;
    width: 100%;
  }
  .no-display {
    display: none !important;
  }
  .d-flex {
    margin: 1% !important;
  }
}
</style>
